import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useAuth } from 'hooks/useAuth';

import { AuthStateHeaders } from 'store/modules/auth';
import ReduxState from 'store/ReduxState';

export const buildGraphaelQueryOptions = (
  isAuthenticated: boolean,
  headers: AuthStateHeaders | undefined,
  locale: string,
) => {
  const platformInfo = {
    platform_version: process.env.COMMIT_REF,
    platform: 'web',
  };

  const userCredentials = isAuthenticated && headers
    ? {
        uid: headers.uid,
        'access-token': headers['access-token'],
        client: headers.client,
      }
    : {};

  const queryOptions = {
    context: {
      headers: {
        ...userCredentials,
        ...platformInfo,
        femtasy_locale: locale,
      },
    },
  };

  return queryOptions;
};

const useGraphaelDefaults = () => {
  const { isAuthenticated } = useAuth();

  const headers = useSelector<ReduxState, AuthStateHeaders | undefined>(
    ({ auth: { headers } }) => headers,
  );

  const { locale } = useIntl();

  return React.useMemo(
    () => buildGraphaelQueryOptions(isAuthenticated, headers, locale),
    [isAuthenticated, headers, locale],
  );
};

export default useGraphaelDefaults;
